export enum SaveStatusEnum {
  saving = "saving",
  success = "success",
  save_failure = "save_failure",
  connection_failure = "connection_failure",
}
